<template>
  <div>
    <div class="header">
      <div class="container-fluid container-boxed">
        <div class="header-body">
          <h6 class="header-pretitle">Graduate</h6>
          <h1 class="header-title">{{ graduate.name }} - Initial Capability Data</h1>
        </div><!-- / .header-body -->
      </div>
    </div><!-- / .header -->

    <div v-if="graduate.id" class="container-fluid container-boxed">
      <loading-spinner v-if="fetching"/>
      <capability-group v-for="group in groupedCapabilities" :group="group" :key="group.id"/>

      <div class="save-actions">
        <div class="text-right">
          <ladda-button :click="discardAndExit" class="btn btn-link btn-discard mr-2">Discard &amp; Exit</ladda-button>
          <ladda-button :click="handleSaveCapabilities" :validate="true" class="btn btn-success">Save</ladda-button>
        </div>
      </div><!-- /.save-actions -->
    </div><!-- /.container-fluid -->
  </div>
</template>

<script>
import { graduateComputed, graduateMethods, graduateCapabilitiesComputed, graduateCapabilitiesMethods } from 'vx/helpers'
import { groupBy, map } from 'lodash'
import { alert } from 'utils'
import CapabilityGroup from './GraduatesSingleInitialCapabilityGroup'

export default {
  props: {
    id: {
      required: true,
      type: Number,
      default: null
    }
  },

  components: {
    CapabilityGroup
  },

  data () {
    return {
      fetching: false
    }
  },

  computed: {
    ...graduateComputed,
    ...graduateCapabilitiesComputed,

    groupedCapabilities () {
      return map(groupBy(this.capabilities, 'group_id'), function (capabilities) {
        return {
          id: capabilities[0].group_id,
          name: capabilities[0].group_name,
          icon: capabilities[0].group_icon,
          capabilities
        }
      })
    }
  },

  async created () {
    this.fetching = true
    await this.resetCapabilities()
    await this.getGraduate(this.id)

    await this.getCapabilities(this.graduate)
    this.fetching = false
  },

  methods: {
    ...graduateMethods,
    ...graduateCapabilitiesMethods,

    async handleSaveCapabilities () {
      let payload = {
        capabilities: map(this.capabilities, (capability) => {
          return {
            id: capability.id,
            program_capability_id: capability.program_capability_id,
            result: capability.result
          }
        })
      }

      try {
        await this.storeCapabilities({ graduate: this.graduate, payload })

        this.$noty.success('Initial capabilities saved.')
        this.$router.push({ name: 'graduates.single', params: { id: this.graduate.id } })
      } catch (error) {
        this.$noty.error('There was a problem saving initial capabilities.')
      }
    },

    async discardAndExit () {
      const confirm = await alert.confirm({
        text: 'Are you sure you want to leave? Any unsaved changes will be lost.'
      })

      if (confirm) {
        this.$router.push({ name: 'graduates.single', params: { id: this.graduate.id } })
      }
    }
  }
}
</script>
